import { useId } from 'react';
import './TextInput.css';

interface Props {
  readonly value: string;
  readonly onChange: (v: string) => void;
  readonly label: string;
  readonly type?: 'text' | 'email';
  readonly autoComplete?: string;
  readonly disabled?: boolean;
  readonly required?: boolean;
  readonly placeholder?: string;
  readonly hint?: string;
}

export default function TextInput({
  value,
  onChange,
  label,
  type = 'text',
  autoComplete,
  disabled,
  required,
  placeholder,
  hint,
}: Props) {
  const id = useId();
  return (
    <div className="om-text">
      <label htmlFor={id} className="om-text__label">
        {label}
      </label>
      <input
        id={id}
        type={type}
        className="om-text__input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoComplete={autoComplete}
        disabled={disabled}
        required={required}
        placeholder={placeholder}
        spellCheck={false}
      />
      {hint ? <p className="om-text__hint">{hint}</p> : null}
    </div>
  );
}
